import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { ProjectHourControlComponent, ProposalHourControlComponent }   from './hour-control.component';
import { ReactiveFormsModule } from '@angular/forms';

import { WeekTimeTableBodyComponent } from '../week-time-table-body/week-time-table-body.component';
import { WeekTimeTableHeaderComponent } from '../week-time-table-header/week-time-table-header.component';
import { WeekTimeTableDialogComponent } from '../week-time-table-dialog/week-time-table-dialog.component';
import { WeekTimeTableComponent } from '../week-time-table/week-time-table.component';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports:      [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  declarations: [
    ProjectHourControlComponent,
    ProposalHourControlComponent,
    WeekTimeTableComponent,
    WeekTimeTableBodyComponent,
    WeekTimeTableHeaderComponent,
    WeekTimeTableDialogComponent
  ],
  exports:      [
    ProjectHourControlComponent,
    ProposalHourControlComponent
  ],
  providers:    [  
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ]
})
export class HourControlModule { }
